import React from 'react'

function ConractUsBanner() {
    return (
        <section className="innerBannerWrapper">
            <img src="/assets/images/contact-banner.webp" alt="" />
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h2 className="txt-white titleMain text-center">CONTACT US</h2>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ConractUsBanner